import axios from 'axios';

import type { WorkflowRuleModel, WorkflowRuleParams } from '~/server_shared/openapi/data-contracts';
import { reportAxiosError } from '~/Utils';

/**
 * API service for workflow rules operations
 */
export class WorkflowRulesApiService {
  /**
   * Create a new workflow rule
   */
  static async createWorkflowRule(organizationId: number, values: WorkflowRuleParams): Promise<WorkflowRuleModel> {
    try {
      const url = `/api/v1/automation/workflow_engine/rules/${organizationId}`;
      const response = await axios.post<WorkflowRuleModel>(url, values);
      return response.data;
    } catch (error) {
      await reportAxiosError(error);
      throw error;
    }
  }

  /**
   * Update an existing workflow rule
   */
  static async updateWorkflowRule(
    organizationId: number,
    ruleId: string,
    values: WorkflowRuleParams
  ): Promise<WorkflowRuleModel> {
    try {
      const url = `/api/v1/automation/workflow_engine/rules/${organizationId}/${ruleId}`;
      const response = await axios.put<WorkflowRuleModel>(url, values);
      return response.data;
    } catch (error) {
      await reportAxiosError(error);
      throw error;
    }
  }

  /**
   * Delete a workflow rule
   */
  static async deleteWorkflowRule(organizationId: number, ruleId: string): Promise<void> {
    try {
      const url = `/api/v1/automation/workflow_engine/rules/${organizationId}/${ruleId}`;
      // Delete returns 204 No Content, so no response body
      await axios.delete(url);
    } catch (error) {
      await reportAxiosError(error);
      throw error;
    }
  }

  /**
   * Enable or disable a workflow rule
   */
  static async setIsWorkflowRuleEnabled(organizationId: number, ruleId: string, isEnabled: boolean): Promise<void> {
    try {
      const url = `/api/v1/automation/workflow_engine/rules/${organizationId}/${ruleId}/enable`;
      await axios.post(url, { is_enabled: isEnabled });
    } catch (error) {
      await reportAxiosError(error);
      throw error;
    }
  }
}
